// extracted by mini-css-extract-plugin
export var container = "profile-modal-module--container--7b9d8";
export var containerContent = "profile-modal-module--container-content--d6dcd";
export var contentSeparateLink = "profile-modal-module--contentSeparateLink--9fca6";
export var svgIcon = "profile-modal-module--svgIcon--faf99";